/**
 * A function that returns nothing and does nothing
 */
export const emptyFunction = () => {};
